import { api } from "@/lib/backend";
import { type ReconcileWindow } from "@/lib/calendar/reconcile";
import { type ShiftForCalendar } from "@/lib/calendar/shift-events";

const PAGE_SIZE = 100;
/**
 * Een dak, geen verwachting. Een halfjaar diensten past ruim binnen duizend; loopt het daar
 * overheen dan is er iets anders aan de hand en is doorpaginaren niet de oplossing.
 */
const MAX_PAGES = 10;

/**
 * De diensten die in de agenda horen te staan, in één keer.
 *
 * Bewust geen `useInfiniteQuery` zoals `use-my-shifts`: die dient een lijst die de medewerker
 * scrollend uitbreidt. Hier moet de synchronisatie het hele venster in handen hebben voordat hij
 * iets mag verwijderen — een halve lijst zou lezen als "die diensten draai ik niet meer".
 */
export async function fetchShiftsForCalendar(
  employeeId: string,
  window: ReconcileWindow,
): Promise<ShiftForCalendar[]> {
  const shifts: ShiftForCalendar[] = [];

  for (let page = 1; page <= MAX_PAGES; page++) {
    const response = await api.shift.getAll({
      pagination: { take: PAGE_SIZE, page },
      sort: { field: "startAt", order: "asc" },
      filter: {
        employeeId: { value: employeeId, operator: "equals" },
        startAt: { value: new Date(window.from).toISOString(), operator: "gte" },
        endAt: { value: new Date(window.to).toISOString(), operator: "lte" },
      },
      include: {
        project: { select: true },
        position: { select: true },
        userFunction: { select: true },
      },
    });

    const items = response.data.items ?? [];
    shifts.push(...items);

    if (shifts.length >= response.data.totalAmount || items.length === 0) {
      break;
    }
  }

  return shifts;
}
